import debounce from "lodash.debounce";

export class ValueEditorsFocusManager {
    private static controls: HTMLElement[] = [];
    private static currentFocusedControlIndex: number = 0;

    private static updateFocusedControls(): void {
        const domElements = this.getAllFocusableElements();
        ValueEditorsFocusManager.controls = [...domElements];
    }

    private static getAllFocusableElements(): HTMLElement[] {
        const domElements = Array.from(document.querySelectorAll<HTMLElement>(this.getAllPageSelectors));
        const multilineActions = Array.from(document.querySelectorAll(`div[data-focus="noFocus"] span[tabindex="0"]`));
        return domElements.filter(element => !multilineActions.includes(element));
    }

    private static get getAllPageSelectors(): string {
        const input = `input:not([type="radio"]):not([type="checkbox"]):not([disabled]):not([type="hidden"])`;
        const select = `span[data-control="select"] button`;
        const picklist = `span[data-focus="focus"] > button`;
        const combobox = `span[data-control="combobox"]`;
        const textarea = `textarea`;
        const excludePageActionsButton = `span[tabindex="0"]:not([data-focus="noFocus"])`;
        return `${picklist}, ${excludePageActionsButton}, ${input}, ${select}, ${combobox}, ${textarea}`;
    }

    public static forceUpdateFocusedByEnterControls = debounce(ValueEditorsFocusManager.updateFocusedControls, 100);

    public static focusOnNextValueEditor(control?: EventTarget): void {
        if (control !== undefined) {
            ValueEditorsFocusManager.focusOnNextValueEditorByControl(control);
        } else {
            ValueEditorsFocusManager.focusOnNextValueEditorByOrder();
        }
    }

    private static focusOnNextValueEditorByControl(control: EventTarget): void {
        const nextControlIndex = ValueEditorsFocusManager.getNextControlIndex(control);
        if (nextControlIndex !== undefined) {
            const nextControl = ValueEditorsFocusManager.controls[nextControlIndex];
            if (nextControl !== undefined) {
                ValueEditorsFocusManager.setCurrentFocusedControlIndex(nextControlIndex);
                ValueEditorsFocusManager.setFocusOnControl(nextControl);
            }
        }
    }

    private static focusOnNextValueEditorByOrder(): void {
        const nextControlIndex = ValueEditorsFocusManager.currentFocusedControlIndex + 1;
        const nextControl = ValueEditorsFocusManager.controls[nextControlIndex];
        if (nextControl !== undefined) {
            ValueEditorsFocusManager.setCurrentFocusedControlIndex(nextControlIndex);
            ValueEditorsFocusManager.setFocusOnControl(nextControl);
        }
    }

    private static getNextControlIndex(control: EventTarget): number | undefined {
        for (let i = 0; i < ValueEditorsFocusManager.controls.length - 1; i++) {
            if (control === ValueEditorsFocusManager.controls[i]) {
                return i + 1;
            }
        }
        return undefined;
    }

    public static setFocusOnControl(control: HTMLElement): void {
        // После выполнения всех функций в контроле
        setTimeout(() => {
            control.focus();
            // @ts-ignore Нужно типизирование для некоторых Input
            const inputElement: HTMLInputElement = control;
            inputElement.click?.();
            inputElement.select?.();
        }, 0);
    }

    public static findPreviousValueEditor(currentInput: EventTarget): HTMLElement | undefined {
        for (let i = 0; i < ValueEditorsFocusManager.controls.length - 1; i++) {
            if (currentInput === ValueEditorsFocusManager.controls[i]) {
                return ValueEditorsFocusManager.controls[i - 1];
            }
        }
        return undefined;
    }

    public static findNextValueEditor(currentInput: EventTarget): HTMLElement | undefined {
        for (let i = 0; i < ValueEditorsFocusManager.controls.length - 1; i++) {
            if (currentInput === ValueEditorsFocusManager.controls[i]) {
                return ValueEditorsFocusManager.controls[i + 1];
            }
        }
        return undefined;
    }

    private static setCurrentFocusedControlIndex(index: number): void {
        ValueEditorsFocusManager.currentFocusedControlIndex = index;
    }

    //Для селекта/комбобокса/пиклиста, где идет перестройка дом дерева после открытия выпадашек
    public static setCurrentValueEditorOrder(currentValueEditor: EventTarget): HTMLElement | undefined {
        for (let i = 0; i < ValueEditorsFocusManager.controls.length - 1; i++) {
            if (currentValueEditor === ValueEditorsFocusManager.controls[i]) {
                ValueEditorsFocusManager.setCurrentFocusedControlIndex(i);
            }
        }
        return undefined;
    }
}
